// Бегущие строки
export default function trackerLine(element, data) {
    // линии - сами бегущие строки
    const tickerLines = document.querySelectorAll('.ticker_line');

    tickerLines.forEach(function(tickerLine) {
        marqueeTrack(tickerLine);
    });
    
    function marqueeTrack(marquee)
    {
        // Их контент
        const tickerText = marquee.querySelector('.ticker_text');
        
        // Дублирование текста на всю ширину
        if (tickerText) {
            // const textContent = tickerText.textContent;
            // const containerWidth = marquee.clientWidth;
            // const textWidth = tickerText.scrollWidth;
            const textContent = tickerText.innerHTML;
            const containerWidth = marquee.clientWidth;
            const textWidth = tickerText.scrollWidth;

            // Определяем, сколько копий текста нужно для заполнения контейнера
            const numCopies = Math.ceil(containerWidth / textWidth * 2);

            // Создаем новый текст, повторяя оригинальный
            const newText = Array(numCopies).fill(textContent).join(' ');

            // Устанавливаем новый текст в элемент
            // tickerText.textContent = newText;
            tickerText.innerHTML = newText;
        }

        var span = marquee.querySelector('span');

        if (span) {
            // Оборачиваем содержимое marquee внутри тега div
            marquee.innerHTML = '<div>' + marquee.innerHTML + '</div>';

            // Находим созданный div внутри marquee который будет двигаться
            var div = marquee.querySelector('div');

            if (div) {
                reset(div);
            }
        }
    }

    function reset(element) {
        element.style.marginLeft = "0%";
        element.animate(
            { marginLeft: "-100%" },
            { duration: 25000, easing: 'linear' }
        ).onfinish = function() {
            reset(element);
        };
    }
};